import { useEffect, useState } from 'react';
import { supabaseStatusStore } from '../utils/supabaseStatus.ts';
import { supabase } from '../services/supabaseClient.ts';

const AUTO_DISMISS_MS = 10000;

export default function SupabaseStatusBanner() {
  const [visible, setVisible] = useState(supabaseStatusStore.get());
  const [retrying, setRetrying] = useState(false);

  useEffect(() => {
    const unsub = supabaseStatusStore.subscribe((down) => {
      setVisible(down);
      if (down) {
        setTimeout(() => setVisible(false), AUTO_DISMISS_MS);
      }
    });
    return () => unsub();
  }, []);

  if (!visible) return null;

  const handleRetry = async () => {
    setRetrying(true);
    try {
      // Try to refresh the Supabase session
      const { error } = await supabase.auth.refreshSession();
      if (!error) {
        console.log('[SupabaseStatusBanner] Session refresh successful');
        setVisible(false);
        supabaseStatusStore.setOutage(false);
      } else {
        console.warn('[SupabaseStatusBanner] Session refresh failed:', error);
      }
      
      // Also try the retry callback if available
      await supabaseStatusStore.retry();
    } catch (err) {
      console.error('[SupabaseStatusBanner] Retry failed:', err);
    } finally {
      setRetrying(false);
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-yellow-900 text-yellow-100 flex items-center justify-center py-3 px-4 shadow-lg animate-fade-in">
      <span className="mr-2 text-2xl">⚠️</span>
      <span>SafeVibe is having trouble connecting to Supabase. Please try again in a moment.</span>
      <button
        className="ml-4 px-3 py-1 bg-yellow-800 hover:bg-yellow-700 text-yellow-100 rounded transition"
        onClick={handleRetry}
        disabled={retrying}
      >
        {retrying ? 'Retrying...' : 'Retry Auth'}
      </button>
      <button
        className="ml-2 px-3 py-1 bg-yellow-800 hover:bg-yellow-700 text-yellow-100 rounded transition"
        onClick={() => { setVisible(false); supabaseStatusStore.setOutage(false); }}
      >
        Dismiss
      </button>
    </div>
  );
} 